import React from "react";
import { Create } from "react-admin";
import BillTypeForm from "./BillTypeForm";

const BillTypeTitle = () => {
  return <span>{`สร้างประเภทบิล`}</span>;
};

export const BillTypeCreate = props => (
  <Create title={<BillTypeTitle />} {...props}>
    <BillTypeForm />
  </Create>
);



// WEBPACK FOOTER //
// ./src/components/billtype/BillTypeCreate.js